import { CometChat } from "@cometchat/chat-sdk-javascript";

export class FriendRequest extends CometChat.User {
  messageId: string;

  constructor(user: CometChat.User, requestId: string) {
    super(user);
    this.messageId = requestId;
  }
}